import React from 'react';
import { navigationLinks, socialLinks } from '../mock';
import { Instagram, Facebook } from 'lucide-react';

const iconMap = {
  Instagram: Instagram,
  Facebook: Facebook
};

const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-950 border-t border-gray-800">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Left: Logo and Tagline */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_gym-launch-site/artifacts/7c6h42gu_TFJ_Print_Original.png" 
                alt="The Fitness Junction Logo" 
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 text-lg font-medium">
              Where Strength Meets Dedication
            </p>
            <p className="text-gray-500 mt-4 text-sm">
              Transform your body and mind at The Fitness Junction. Your journey to greatness starts here.
            </p>
          </div>

          {/* Center: Quick Links */}
          <div>
            <h3 className="text-white font-bold text-xl mb-4">Quick Links</h3>
            <ul className="space-y-3">
              {navigationLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-gray-400 hover:text-brand-primary transition-colors duration-300 font-medium"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: Social Media */}
          <div>
            <h3 className="text-white font-bold text-xl mb-4">Follow Us</h3>
            <p className="text-gray-400 mb-4">
              Stay connected and get fitness tips, updates, and motivation.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social) => {
                const IconComponent = iconMap[social.icon];
                return (
                  <a
                    key={social.id}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-brand-primary hover:scale-110 transform transition-all duration-300 group"
                  >
                    {IconComponent && (
                      <IconComponent className="text-gray-400 group-hover:text-black transition-colors duration-300" size={20} />
                    )}
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} The Fitness Junction. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <button className="text-gray-500 hover:text-brand-primary transition-colors duration-300">
                Privacy Policy
              </button>
              <button className="text-gray-500 hover:text-brand-primary transition-colors duration-300">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


